


import React, { useState } from "react";
import { useTranslation } from "src/context/Translations/context";
import Container from "src/components/Sortable/Container";
import { verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import SortableItem from "src/components/Sortable/Item";
import { arrayMove, RCCHookToast, RCCServicesApi } from "react-common-components";
import { standardErrorMessages } from "src/utils/errors";
import useEffectSkipInitialRender from "src/hooks/useEffectSkipInitialRender";
import { restrictToVerticalAxis } from "src/components/Sortable/Container/modifiers";
import { ISidebarCanvas } from "./interface";
import { ICatbb001 } from "../../interface";
import CanvasCard from "./components/Card";


const SidebarCanvas: React.FC<ISidebarCanvas> = ({
	items,
	setItems,
	refModalCanvas,
	onClickCardFuncion,
	selectedCanvas
}) => {

	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();

	const [tempItems, setTempItems] = useState<ICatbb001[]>(items);

	const [activeId, setActiveId] = useState<string | null>(null);
	const [isDragging, setIsDragging] = useState<boolean>(false);
	const [waitingForResponse, setWaitingForResponse] = useState(false);

	const queryReorderCanvas = async (kanbans: any[]) => {
		setWaitingForResponse(true);
		try{
			await RCCServicesApi.putRequest({
				method: "Canvas/UpdateOrder",
				body: {
					rows: kanbans
				}
			});
			setWaitingForResponse(false);
			
			addToast({
				color: "green",
				description: translate("Canvas movido com sucesso"),
				title: translate("Sucesso")
			});

			return true;
		}catch(err){
			setItems(tempItems);
			standardErrorMessages(err, translate("Erro ao atualizar ação"), addToast);
			setWaitingForResponse(false);
			return false;
		}
	};

	const disableOptions = (idX: string) => {
		if(isDragging){
			if(activeId === idX)
				return false;
			return true;
		}
		if(waitingForResponse)
			return true;
		return false;
	};

	useEffectSkipInitialRender(() => {
		setItems(items);
	}, [items]);

	return (
  	<>
  		<Container
				onDragStart={(activeIdX: string) => {
					setIsDragging(true);
					setActiveId(activeIdX);
					setTempItems(items);
				}}
				executeOnDragEndWhenActiveAndOverEquals
  			onDragEnd={(activeIdX, overId) => {
					setIsDragging(false);
					setActiveId(null);

					if(activeIdX === overId)
						return; 	

					const activeIndex = items.findIndex((checks) => checks.id === activeIdX);
					const overIndex = items.findIndex((checks) => checks.id === overId);

					const orderedItems = arrayMove(items, activeIndex, overIndex);

					setItems(orderedItems);

					const rowsOrdered: any[] = [];

					orderedItems.forEach((item: any, index) => {
						const row = {
							cab001Id: item.cab001Id,
							cab001Ordem: index + 1
						};
						rowsOrdered.push(row);
					});

					queryReorderCanvas(rowsOrdered);

  			}}
  			items={items.map((line) => ({
  				id: `${line.cab001Id}`
  			}))}
				modifiers={[restrictToVerticalAxis]}
				strategy={verticalListSortingStrategy}
  		>	
				{items.map((value) => (
					<SortableItem 
						key={value.cab001Id}
						id={`${value.cab001Id}`}
					>
						<CanvasCard 
							data={value}
							selected={selectedCanvas === value.cab001Id}
							disableOptions={disableOptions(value.id)}
							openModalChangeCanvas={refModalCanvas.current?.actionButtonChange}
							openModalDeleteCanvas={refModalCanvas.current?.actionButtonDelete}
							onClickCardFuncion={onClickCardFuncion}
						/>
					</SortableItem>
				))}
  		</Container>

		</>
	);
};

export default SidebarCanvas;
